import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ContractSectionGuard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const section = route.paramMap.get('section');
    return section === 'contract';
  }
}
